import {
  BAYTEK_CODE,
  BEHR_CODE,
  CAPITAL_WRAPS_CODE,
  COAST_CODE,
  EVERCONNECT_CODE,
  getBasePartnerCode,
  GUSTO_CODE,
  HD_SUPPLY_CODE,
  HDX_CODE,
  NOVO_CODE,
  POSTCARDMANIA_CODE,
  RINNAI_CODE,
  SPARTAN_TOOL_CODE,
  SUNBELT_RENTALS_CODE,
  WESUPPLYTRADES_CODE,
  WINSUPPLY_CODE,
} from '../constants';
import { PartnerEnrollmentStatus } from '../enums';

// Keyed by partner CODE (stable) rather than name, so a Retool rename does not
// break the enrollment-status message lookup. The value is the i18n sub-key.
// SN-838.
const actionRequiredMessageKeys: Record<string, string> = {
  [RINNAI_CODE]: 'rinnai',
  [NOVO_CODE]: 'novoProfessionalWaterSystems',
  [HDX_CODE]: 'hdx',
  [BEHR_CODE]: 'behr',
  [WESUPPLYTRADES_CODE]: 'weSupplyTrades',
  [SPARTAN_TOOL_CODE]: 'spartanTool',
  [COAST_CODE]: 'coast',
  [WINSUPPLY_CODE]: 'winsupply',
  [SUNBELT_RENTALS_CODE]: 'sunbeltRentals',
  [HD_SUPPLY_CODE]: 'hdSupply',
};

const inProgressMessageKeys: Record<string, string> = {
  [CAPITAL_WRAPS_CODE]: 'capitalWraps',
  [BAYTEK_CODE]: 'baytek',
  [GUSTO_CODE]: 'gusto',
  [EVERCONNECT_CODE]: 'everConnect',
  [POSTCARDMANIA_CODE]: 'postcardMania',
  [COAST_CODE]: 'partnerVerification',
  [HD_SUPPLY_CODE]: 'partnerVerification',
  [SPARTAN_TOOL_CODE]: 'partnerVerification',
  [SUNBELT_RENTALS_CODE]: 'partnerVerification',
  [WESUPPLYTRADES_CODE]: 'partnerVerification',
  [WINSUPPLY_CODE]: 'partnerVerification',
};

export function getPartnerEnrollmentStatusMessageKey(
  partnerCode: string | undefined,
  status: PartnerEnrollmentStatus,
): string | undefined {
  // The maps hold edge-tier codes; a paid/SRT partner's code carries the
  // suffix, so strip it before lookup (both tiers share the same message).
  const baseCode = getBasePartnerCode(partnerCode || '');

  if (status === PartnerEnrollmentStatus.ActionRequired) {
    return `partnerDetails.enrollmentStatus.messages.actionRequired.${
      actionRequiredMessageKeys[baseCode] || 'generic'
    }`;
  }

  if (status === PartnerEnrollmentStatus.InProgress) {
    return `partnerDetails.enrollmentStatus.messages.inProgress.${
      inProgressMessageKeys[baseCode] || 'generic'
    }`;
  }

  return undefined;
}
